import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import PostPage from './pages/PostPage';
import AboutPage from './pages/AboutPage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import EditPostPage from './pages/EditPostPage';
import NewPostPage from './pages/NewPostPage';
import AnalyticsPage from './pages/AnalyticsPage';
import analytics from './services/analytics';
import './App.css';

// Component to track page views
function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        // Don't track admin pages
        if (!location.pathname.startsWith('/admin')) {
            analytics.trackPageView(location.pathname);
        }
    }, [location]);

    return null;
}

function App() {
    return (
        <Router>
            <div className="App">
                <AnalyticsTracker />
                <main>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/blog" element={<BlogPage />} />
                        <Route path="/post/:slug" element={<PostPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/admin/login" element={<LoginPage />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />
                        <Route path="/admin/analytics" element={<AnalyticsPage />} />
                        <Route path="/admin/edit/:slug" element={<EditPostPage />} />
                        <Route path="/admin/new-post" element={<NewPostPage />} />
                    </Routes>
                </main>
            </div>
        </Router>
    );
}

export default App;
